import { render, staticRenderFns } from "./XaridKomissiyasi.vue?vue&type=template&id=7a0b10b7&"
import script from "./XaridKomissiyasi.vue?vue&type=script&lang=js&"
export * from "./XaridKomissiyasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports